import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { SpecSummary } from '../../types/project.js';

@customElement('cp-spec-card')
export class CpSpecCard extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Object }) spec!: SpecSummary;
  @property({ type: Number }) projectId!: number;

  private _onClick(): void {
    this.dispatchEvent(new CustomEvent('spec-select', {
      bubbles: true,
      composed: true,
      detail: { specId: this.spec.id, projectId: this.projectId },
    }));
  }

  private _formatDate(iso: string): string {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return iso;
    }
  }

  private _statusLabel(status: SpecSummary['status']): string {
    switch (status) {
      case 'not-started': return 'Nicht gestartet';
      case 'in-progress': return 'In Arbeit';
      case 'complete': return 'Abgeschlossen';
      case 'error': return 'Fehler';
      default: return status;
    }
  }

  render() {
    const { spec } = this;
    if (!spec) return html``;

    const { storyCounts, progressPercent } = spec;

    return html`
      <div class="cp-spec-card" @click=${this._onClick}>
        <div class="cp-spec-card__header">
          <h3 class="cp-spec-card__name">${spec.name}</h3>
          <span class="cp-spec-card__badge cp-spec-card__badge--${spec.status}">
            ${this._statusLabel(spec.status)}
          </span>
        </div>
        <p class="cp-spec-card__date">${this._formatDate(spec.createdAt)}</p>
        <div class="cp-spec-card__progress">
          <div class="cp-spec-card__progress-bar">
            <div
              class="cp-spec-card__progress-fill"
              style="width: ${progressPercent}%"
            ></div>
          </div>
          <span class="cp-spec-card__progress-text">${progressPercent}%</span>
        </div>
        <div class="cp-spec-card__stories">
          <span class="cp-spec-card__story-count">${storyCounts.done}/${storyCounts.total} done</span>
          ${storyCounts.inProgress > 0 ? html`
            <span class="cp-spec-card__story-active">${storyCounts.inProgress} in progress</span>
          ` : html``}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-spec-card': CpSpecCard;
  }
}
